/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_GlanceInputs */

const en_wc_vs_glance = /** @type {(inputs: Wc_Vs_GlanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At a glance`)
};

/**
* | output |
* | --- |
* | "At a glance" |
*
* @param {Wc_Vs_GlanceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_glance = /** @type {((inputs?: Wc_Vs_GlanceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_GlanceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_glance(inputs)
});
export { wc_vs_glance as "wc.vs.glance" }